window.playRing = () => {
    const ring = document.getElementById('ring')

    ring.currentTime = 0
    ring.play().catch(error => {});
}